module.exports = __webpack_public_path__ + "static/media/team-4-800x800.8b457fc3.jpg";